import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type {
	GroupsAndUsersEndpointResponse,
	InfoQueryEndpointResponse,
} from './GroupsAndUsersEndpointResponse.types.tsx';

const fetchGrantedPermissions = (): Promise<InfoQueryEndpointResponse> =>
	performPostRequest('/rest/roadmaps/1.0/info/query', {
		body: JSON.stringify({
			providers: ['permissions'],
		}),
	});

const fetchPermissionGroups = (): Promise<GroupsAndUsersEndpointResponse> =>
	performPostRequest('/rest/jpo/1.0/groupsandusers', {
		body: JSON.stringify({
			includeUsers: false,
			excludedGroups: [],
			excludedUsers: [],
			query: '',
		}),
	});

export const grantedPermissionsResource: RouteResource<InfoQueryEndpointResponse> =
	createResource<InfoQueryEndpointResponse>({
		type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
		getKey: () => 'arj-granted-permissions',
		getData: async () => fetchGrantedPermissions(),
		maxAge: 0,
	});

export const permissionGroupsResource: RouteResource<GroupsAndUsersEndpointResponse> =
	createResource<GroupsAndUsersEndpointResponse>({
		type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
		getKey: () => 'arj-permission-groups',
		getData: async () => fetchPermissionGroups(),
		maxAge: 0,
	});

export const getGlobalPermissionPageResources = (): (
	| RouteResource<InfoQueryEndpointResponse>
	| RouteResource<GroupsAndUsersEndpointResponse>
)[] => [grantedPermissionsResource, permissionGroupsResource];
